export const adminCommunity = {
  "admin.community.communityGenealogyTree.title": "Topluluk Soy Ağacı",
  "admin.community.communityGenealogyTree.subtitle": "Tam referans yapısını görselleştirin ve keşfedin",
  "admin.community.communityGenealogyTree.loading": "Soy ağacı yükleniyor...",
  "admin.community.communityGenealogyTree.error": "Soy ağacı yüklenirken hata",
  "admin.community.communityGenealogyTree.searchLabel": "Kullanıcı Adına Göre Ara",
  "admin.community.communityGenealogyTree.searchPlaceholder": "Kullanıcı adı girin...",
  "admin.community.communityGenealogyTree.searchButton": "Ağacı Yükle",
  "admin.community.communityGenealogyTree.resetButton": "Görünümü Sıfırla",
  "admin.community.communityGenealogyTree.userNotFound": "Kullanıcı bulunamadı",
  "admin.community.communityGenealogyTree.searchError": "Kullanıcı aranırken hata",
  "admin.community.communityGenealogyTree.invalidUser": "Geçersiz kullanıcı belirtildi",
  
  "admin.community.treeNode.expand": "Genişlet",
  "admin.community.treeNode.collapse": "Daralt",
  "admin.community.treeNode.directReferrals": "Doğrudan Referanslar",
  "admin.community.treeNode.loading": "Yükleniyor...",
  
  "admin.community.errors.accessDenied": "Erişim reddedildi: yetersiz izinler",
  "admin.community.errors.userNotFound": "Kullanıcı bulunamadı",
  "admin.community.errors.networkError": "Sayfayı Yenile",
  "admin.community.errors.unexpectedError": "Beklenmeyen bir hata oluştu"
};
